import { RewardVault } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike } from "ethers";

export type ClaimData = {
  user: string;
  claimed: bigint;
  available: bigint;
  totalReward: bigint;
};

export type VaultData = {
  active : boolean;
  totalFunded: bigint;
  totalClaimed: bigint;
  feeder: AddressLike;
  stakingToken: AddressLike;
  rewardToken: AddressLike;
}

export const PAUSER_ROLE = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<string> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).PAUSER_ROLE();

export const SETTER_ROLE = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<string> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).SETTER_ROLE();

export const FUNDER_ROLE = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<string> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).FUNDER_ROLE();

export const DEFAULT_ADMIN_ROLE = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<string> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).DEFAULT_ADMIN_ROLE();

export const GetStakingToken = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<AddressLike> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).stakingToken();

export const GetRewardToken = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<AddressLike> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).rewardToken();

export const GetRewardFeeder = async (
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<AddressLike> =>
  await (
    contracts.getContractByName(contractName) as unknown as RewardVault
  ).feeder();

export async function GetUserClaimData(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
  user: AddressLike,
): Promise<ClaimData> {
  const vault = contracts.getContractByName(
    contractName,
  ) as unknown as RewardVault;
  return await vault.getUserClaimData(user);
}

export async function GetVaultData(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardVault,
): Promise<VaultData> {
  const vault = contracts.getContractByName(
    contractName,
  ) as unknown as RewardVault;
  return await vault.getVaultData();
}

export const GetterMethods = {
  PAUSER_ROLE,
  SETTER_ROLE,
  FUNDER_ROLE,
  DEFAULT_ADMIN_ROLE,
  GetStakingToken,
  GetRewardToken,
  GetRewardFeeder,
  GetUserClaimData,
  GetVaultData,
};

export default GetterMethods;
